export default "__VITE_ASSET__2fa3914e__"